(function () {
  'use strict';

  var STORAGE_KEY = 'pcs_postal_code';
  var POSTAL_INPUT_SELECTOR = 'input[name="contact[postal_code]"]';

  function normalizePostalCode(value) {
    if (value === null || value === undefined) return '';
    var digits = String(value).replace(/\D/g, '');
    if (digits.length < 5) return '';
    return digits.slice(0, 5);
  }

  function safeReadStoredPostalCode() {
    try {
      return normalizePostalCode(localStorage.getItem(STORAGE_KEY));
    } catch (e) {
      return '';
    }
  }

  function shouldPrefillInput(inputEl) {
    // Respect user's input if they already typed something.
    if (!inputEl) return false;
    if (typeof inputEl.value !== 'string') return false;
    return inputEl.value.trim() === '';
  }

  function applyPostalCodeToInputs(postalCode) {
    if (!postalCode) return;
    var inputs = document.querySelectorAll(POSTAL_INPUT_SELECTOR);
    if (!inputs || inputs.length === 0) return;

    inputs.forEach(function (inputEl) {
      if (!shouldPrefillInput(inputEl)) return;
      inputEl.value = postalCode;
      // Trigger events so downstream scripts relying on change can react.
      inputEl.dispatchEvent(new Event('input', { bubbles: true }));
      inputEl.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function init() {
    var currentPostalCode = safeReadStoredPostalCode();
    if (currentPostalCode) applyPostalCodeToInputs(currentPostalCode);

    document.addEventListener('pcs:postal-code-set', function (e) {
      var nextPostalCode = normalizePostalCode(
        e && e.detail ? e.detail.postalCode : ''
      );

      if (!nextPostalCode) {
        nextPostalCode = safeReadStoredPostalCode();
      }

      if (!nextPostalCode) return;

      currentPostalCode = nextPostalCode;
      applyPostalCodeToInputs(currentPostalCode);
    });

    // Handles contact forms injected after page load (modals, drawers, etc.).
    var observer = new MutationObserver(function (mutations) {
      if (!currentPostalCode) return;

      var foundPostalInputInMutation = mutations.some(function (mutation) {
        if (!mutation || !mutation.addedNodes) return false;

        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return false;
          if (node.matches && node.matches(POSTAL_INPUT_SELECTOR)) return true;
          if (node.querySelector) {
            return node.querySelector(POSTAL_INPUT_SELECTOR) !== null;
          }
          return false;
        });
      });

      if (foundPostalInputInMutation) {
        applyPostalCodeToInputs(currentPostalCode);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

